export default "__VITE_ASSET__irbtmj7Y__"